import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly auth = inject(AuthService);

  intercept<T>(
    req: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T | never>> {
    return this.getHandle(req, next);
  }

  private getHandle<T>(
    req: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T>> {
    const isAuthUrl = /authenticationlink|accesstoken|oauth-loginsession/.test(
      req.url
    );
    const isUploadUrl = /upload/.test(req.url);
    const isUiRequest = req.url.includes('en.json');
    let headers = !isUploadUrl
      ? new HttpHeaders({
          'Content-Type': 'application/json',
        })
      : req.headers;

    if (this.auth.accessToken && !isAuthUrl && !isUiRequest) {
      headers = headers.set('Authorization', `Bearer ${this.auth.accessToken}`);
    }

    const authReq = req.clone({
      headers,
    });

    return next.handle(authReq);
  }
}
